import React from 'react';
import { AlertTriangleIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
const includes = ['6 Tomos completos en PDF (300+ páginas)', 'Bono 1 — Recetario Dulce Fit Anti-Ansiedad', 'Bono 2 — Guía de Suplementación Inteligente', 'Video Masterclass — Técnica perfecta de glúteos', 'Checklists y planillas de seguimiento'];
export function PricingSection() {
  return <section id="comprar" className="w-full scroll-mt-4 bg-ink-950 py-20" aria-labelledby="pricing-title" data-id="element-180" data-mp="1s93yxa3hwh1w">
      <div className="mx-auto max-w-3xl px-5" data-id="element-181" data-mp="1x8gkzsmjlk3f">
        <CountdownTimer label="Precio de lanzamiento — cierra en:" data-id="element-182" data-mp="1x6ndkb43uvud" />

        <p className="mt-6 flex items-center justify-center gap-2 text-center text-sm text-rose-400" data-id="element-183" data-mp="226i4ufrslnfy">
          <AlertTriangleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-184" data-mp="2w0goxdb4g17" />
          Después del contador sube de precio. Sin vuelta atrás.
        </p>

        <div className="mt-6" data-id="element-185" data-mp="1mgentl4weydl">
          <div className="h-2 w-full overflow-hidden rounded-full bg-cream/10" data-id="element-186" data-mp="1mhq069cetegb">
            <div className="h-full w-[72%] rounded-full bg-rose-500" data-id="element-187" data-mp="1hpg7iljwu0ac" />
          </div>
          <p className="mt-2 text-center text-xs text-cream/60" data-id="element-188" data-mp="1cqlmre2du1nl">
            72% de los cupos al precio de lanzamiento ya tomados — quedan pocos
          </p>
        </div>

        <h2 id="pricing-title" className="mt-14 text-center font-display text-3xl uppercase text-cream sm:text-4xl" data-id="element-189" data-mp="17ppc8hnizh97">
          Elegí tu MegaPack
        </h2>
        <p className="mt-3 text-center text-sm text-cream/60" data-id="element-190" data-mp="20h8v20g7mtao">
          Un solo precio. Un solo pago. Acceso de por vida.
        </p>

        <div className="mt-8 overflow-hidden rounded-3xl border border-gold-500/40 bg-ink-800 shadow-[0_30px_80px_-40px_rgba(232,182,90,0.5)]" data-id="element-191" data-mp="1rg1asmaj3szl">
          <div className="bg-gold-500 px-6 py-3 text-center font-display text-sm uppercase tracking-[0.2em] text-ink-950" data-id="element-192" data-mp="k3r5sr4rxkev">
            MegaPack Reto 30 días fit
          </div>

          <div className="px-6 py-8 sm:px-10" data-id="element-193" data-mp="hhhyyytws6c6">
            <p className="text-center text-sm text-cream/70" data-id="element-194" data-mp="hfowzwu8qaai">
              6 Tomos + 2 Bonos + 1 Video Masterclass
            </p>
            <p className="mt-1 text-center text-xs uppercase tracking-wide text-rose-400" data-id="element-195" data-mp="7k3mfab3w1p5">
              Ideal para: tu transformación completa en 30 días
            </p>

            <div className="mt-7 flex flex-col items-center" data-id="element-196" data-mp="ckhxl1807rre">
              <span className="text-lg text-cream/40 line-through" data-id="element-197" data-mp="3uvwbf0wglfbv">$89.000</span>
              <span className="font-display text-5xl text-gold-500 sm:text-6xl" data-id="element-198" data-mp="3j1wxl6zr40d">$19.990</span>
              <span className="mt-2 text-xs uppercase tracking-wide text-cream/55" data-id="element-199" data-mp="3kz9ps9wb6k8s">
                Pago único · Acceso inmediato · Tuyo para siempre
              </span>
            </div>

            <ul className="mx-auto mt-8 flex max-w-md flex-col gap-2.5" data-id="element-200" data-mp="3bxa8dghdte5b">
              {includes.map(item => <li key={item} className="flex items-start gap-3 text-sm text-cream/80" data-id="element-201" data-mp="3fyc77w7dzo6r">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold-500/15" data-id="element-202" data-mp="2xabihpy6arsp">
                    <CheckIcon className="h-3 w-3 text-gold-500" aria-hidden="true" data-id="element-203" data-mp="2sdbkm2bh8vco" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-9" data-id="element-204" data-mp="31bn83vh1rd0w">
              <CtaButton data-id="element-205" data-mp="31eszxih28t0b">Quiero mi MegaPack ahora</CtaButton>
            </div>

            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-cream/55" data-id="element-206" data-mp="3g8ebeftud8vs">
              <span className="inline-flex items-center gap-1.5" data-id="element-207" data-mp="3b8rzqatnw0p3">
                <LockIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-208" data-mp="3p17xaw3sn6im" /> Pago 100% seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-209" data-mp="3l1h82wtx0yg7">
                <ZapIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-210" data-mp="2w48bb7ylr3r" /> Acceso en 5 minutos
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-211" data-mp="3u2x9wg6nzs8t">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-212" data-mp="hyvx8d3wteoq" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-3 text-center text-[11px] uppercase tracking-[0.16em] text-cream/40" data-id="element-213" data-mp="lxuvjev4yd77">
              Mercado Pago — Tarjeta — Transferencia
            </p>
          </div>
        </div>
      </div>
    </section>;
}